import { EndpointResolverService } from '../services/endpoint-resolver.service';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';



export function endPointResolverInitializer(provider: EndpointResolverService, router: Router) {
  return () => new Promise((resolve, reject) => {
    provider.load().then(() => {
      resolve(true);
    }).catch(err => {
      errorPreloader();
      reject();
    });
  });
}

function errorPreloader() {
  const preloader: HTMLElement = document.querySelector('.preloader');
  preloader.style.background = 'url(../../../assets/img/preloader/preloader.error.jpg) #000 no-repeat center center fixed';

  setTimeout(() => {
    preloader.innerHTML = `<div class="wrapper" style="height:100%;">
          <div class="abs-center w-50 ng-slideInDown"  style="top:50%">
              <!-- START card-->
              <div class="card mt-50">
                  <div class="card-body">
                      <div class="text-center mb-4">
                          <div class="text-lg mb-3">Error Loading Application</div>
                          <p class="lead m0">Unable to load API surface, please try again later.</p>
                          <h4>Support Info</h4>
                          <p><em class="fas fa-user"></em> ${environment.ui.supportContact}<br />
                          <em class="fas fa-at"></em> <a href="mailto:${environment.ui.supportAddress}">${environment.ui.supportAddress}</a></p>
                      </div>
                  </div>
              </div>
          </div>
      </div>`;
  }, 500);

}
